import type { EventName } from "@lit/react";
import { Popover as PopoverElement, type PopoverEventMap as _PopoverEventMap, } from "@vaadin/popover/vaadin-popover.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { PopoverElement, };
export type PopoverEventMap = Readonly<{
    onClosed: EventName<_PopoverEventMap["closed"]>;
    onOpenedChanged: EventName<_PopoverEventMap["opened-changed"]>;
}>;
const events = { onClosed: "closed", onOpenedChanged: "opened-changed" } as PopoverEventMap;
export type PopoverProps = WebComponentProps<PopoverElement, PopoverEventMap>;
export const Popover = createComponent({
    elementClass: PopoverElement, events, react: React, tagName: "vaadin-popover"
});
